
// Add to cart stacky class add code Start 
var page = __st.p
    // console.log(page);
if (page == "product"){
   var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
   // console.log(screenWidth);
   function loadMoreItems() {
    const screenWidth = window.innerWidth; // Get the current screen width
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollBottom = scrollTop + windowHeight; // Declare scrollBottom here
    const buyButtons = document.querySelector(".ct-sticky-pro-btn-main");    
    if (screenWidth <= 768) {
        // console.log("768 " + scrollBottom);
        if (scrollTop === 0 || scrollBottom < 2050) {
            buyButtons.classList.remove("ct-btn-fixed");
        } else if (scrollBottom < 3750 && scrollBottom > 2050) {
            buyButtons.classList.add("ct-btn-fixed");
        }
    } else {
        // Adjust the conditions according to your needs
        if (scrollTop === 0 || scrollBottom < 1720) {
            buyButtons.classList.remove("ct-btn-fixed");
        } else if (scrollBottom < 3750 && scrollBottom > 1500) {
            buyButtons.classList.add("ct-btn-fixed");
        }
    }
}
window.addEventListener('scroll', loadMoreItems); 

// trigger aad to cart button 
var Sbutton = document.querySelector(".ct_triger_addto");   
Sbutton.addEventListener('click', function () {
 document.querySelector('.product-form__submit').click();
})
}

const stprice_var = document.querySelectorAll(".ct_variant_selects label");
const print_price = document.querySelector(".ct-sticky-pro-price-main");
// console.log(print_price);
stprice_var.forEach(pricev => {
  pricev.addEventListener('click', function() { 
    setTimeout(() => {
      const V_price = document.querySelector(".ct-pro-price-main .price__sale .ct-sale-price").textContent;
      // console.log(V_price);
      print_price.innerHTML = V_price;
    }, 1500);
  });
});
// Add to cart stacky class add code End


// CT FAQ Section JS  start
const pagef = __st.pageurl;
// console.log(page)
if(pagef == 'veganday.in/pages/faqs'){
const questionTitles = document.querySelectorAll('.ct-vegen-faq-heading-main');
  console.log("FAQ");
// Add click event listener to each question title
questionTitles.forEach(title => {
    title.addEventListener('click', () => {
        // Toggle 'is_open' class on the clicked question title
        title.classList.toggle('is_open');
        
        // Get corresponding answer text element
        const answerText = title.nextElementSibling;
        
        // Toggle 'is_open' class on the corresponding answer text
        answerText.classList.toggle('is_open');
        
        // Close other answer texts if opened
        questionTitles.forEach(otherTitle => {
            if (otherTitle !== title && otherTitle.classList.contains('is_open')) {
                otherTitle.classList.remove('is_open');
                otherTitle.nextElementSibling.classList.remove('is_open');
            }
        });
    });
});
}
// CT FAQ Section JS  END  


// CSS Auto scroll JS
    var sliders = document.querySelectorAll('.ct_items_scroll');
    var isDown = false;
    var startX;
    var scrollLeft;
    
    sliders.forEach(slider => {
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
    
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
        enableLinks(); // Re-enable links on mouse leave
      });
    
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
        enableLinks(); // Re-enable links on mouse up
      });
    
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; // scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        disableLinks(); // Disable links when scrolling horizontally
      });
    });
    
    function disableLinks() {
      var links = document.querySelectorAll('.ct_items_scroll .ct-scroll-box');
      links.forEach(link => {
        link.style.pointerEvents = 'none'; // Disable link clicks
      });
    }
    
    function enableLinks() {
      var links = document.querySelectorAll('.ct_items_scroll .ct-scroll-box');
      links.forEach(link => {
        link.style.pointerEvents = 'auto'; // Re-enable link clicks
      });
    }
